import React from 'react';

import BasicStep from './BasicStep';
import BusinessHours from '../BusinessHours';
import SoftwareChoice from '../Forms/SoftwareChoice';
import TurnoverChoice from '../Forms/TurnoverChoice';
import Responsibles from '../Forms/Responsibles';
import Coordinate from '../Forms/Coordinate';
import GeneralCondition from '../Forms/GeneralCondition';


export default class PharmacyCoordinate extends BasicStep {
  constructor(props) {
    super(props);

    this.state = {
      pharmacy: props.getStore().pharmacy,
      validationErrors: { },
      businessHoursErrors: {},
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  // not required as this component has no forms or user entry
  // isValidated() {}
  isValidated() {
    return new Promise((resolve, reject) => {
      const hasError = !this.checkForm();

      if (hasError) {
        reject(); // form contains errors
        return;
      }

      //if (this.props.getStore().emailEmergency != this.getValidatorData().emailEmergency) { // only update store of something changed
        this.props.updateStore({
          ...this.getValidatorData(),
          savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
        });  // Update store here (this is just an example, in reality you will do it via redux or flux)
      //}

      resolve(); // form is valid, fire action
    });
  }

  getValidatorData() {

    let object = this.props.getStore();
    object.pharmacy.selectedSoftware = this.refs["SoftChoice"].getObject().selectedSoftware;
    object.pharmacy.softwareWillChange = this.refs["SoftChoice"].getObject().softwareWillChange;
    object.pharmacy.softwareHasChanged = this.refs["SoftChoice"].getObject().softwareHasChanged;
    object.pharmacy.softwareOtherFuture = this.refs["SoftChoice"].getObject().softwareOtherFuture;


    object.pharmacy.softwareOther = this.refs["SoftChoice"].getObject().softwareOther;
    object.pharmacy.selectedTurnover = this.refs["turnoverChoice"].getObject().selectedTurnover;
    object.pharmacy.communicationMonth = this.refs["turnoverChoice"].getObject().communicationMonth;
    object.pharmacy.responsibles = this.refs["responsibles"].getObject();
    //object.pharmacy.hasCheckedGeneralCondition = this.refs["condition"].getObject();
    object.pharmacy = this.state.pharmacy;

    return object;
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    let formsChecked = [];
    formsChecked["coordinate"] = this.refs["coordinate"].checkForm();
    formsChecked["SoftChoice"] = this.refs["SoftChoice"].checkForm();
    formsChecked["turnoverChoice"] = this.refs["turnoverChoice"].checkForm();
    formsChecked["responsibles"] = this.refs["responsibles"].checkForm();
    //formsChecked["condition"] = this.refs["condition"].checkForm();

    let isOk = true;
    let whereToRedirect = "";
    let arrSections = ["coordinate","responsibles","SoftChoice","turnoverChoice"];
    for(let i in arrSections)
    {
      isOk = isOk && this.refs[arrSections[i]].checkForm();
      if (!isOk && whereToRedirect == ""){
        whereToRedirect = arrSections[i];
      }
    }

    isOk = isOk && (Object.keys(this.state.businessHoursErrors).length === 0);
    //on va scroller s'il y a une erreur
    if (!isOk){
      //si ce n'est pas défini, ce sont le sheures
      if (whereToRedirect == ""){
        whereToRedirect="opening-hours"
      }
      document.getElementById(whereToRedirect).scrollIntoView({ block: 'start',  behavior: 'smooth' });
    }
    return isOk
  }

  onError = (errors) => {
    this.setState({
      businessHoursErrors: errors,
    });
  }

  render() {
    return (
      <div className="step step1">
        <form className="form">
          <Coordinate
            id="coordinate"
            ref="coordinate"
            coordinate={this.state.pharmacy.coordinate}
          />

          <Responsibles
              id="responsibles"
              ref="responsibles"
              responsibles={this.props.getStore().pharmacy.responsibles}
          />

          <fieldset className="form-fieldset" id="opening-hours">
            <legend className="form-fieldset-legend">Heures d'ouverture</legend>
            <p className="margin-bottom-s">
              Pour spécifier l'heure les formats suivants sont autorisés :
              <ul>
                <li>08:00-19:00 Pour 8 heures à 19 heures en continue</li>
                <li>08:00-12:00 14:00-19:30 Pour de 8 heures à midi le matin. Puis, de 14 heures à 19 heures 30 pour l'après-midi</li>
              </ul>
            </p>
            <BusinessHours businessHours={this.state.pharmacy.businessHours} onError={this.onError}/>
          </fieldset>

          <SoftwareChoice
            id="SoftChoice"
            ref="SoftChoice"
            softwares={this.props.getStore().softwares} 
            selectedSoftware={this.state.pharmacy.selectedSoftware} 
            softwareOther={this.state.pharmacy.softwareOther}
            softwareWillChange={this.state.pharmacy.softwareWillChange}
            softwareHasChanged={this.state.pharmacy.softwareHasChanged}
            softwareOtherFuture={this.state.pharmacy.softwareOtherFuture}
          />

          <TurnoverChoice
            id="turnoverChoice"
            ref="turnoverChoice"
            turnovers={this.props.getStore().turnovers}
            selectedTurnover={this.state.pharmacy.selectedTurnover}
            communicationMonth={this.state.pharmacy.communicationMonth}
          />
        </form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/PharmacyCoordinate.js